import { Link, useNavigate } from "react-router-dom";
import { useMemo, useState } from "react";
import { filterTitles, getTrending, type SortValue } from "@/utils/catalog";
import FilmCard from "@/components/feature/FilmCard";
import { SectionTitle } from "@/components/base/Rating";

const tabs: { key: "latest" | "rating" | "popular"; label: string }[] = [
  { key: "latest", label: "最新上线" },
  { key: "rating", label: "高分佳作" },
  { key: "popular", label: "热门推荐" },
];

export default function LatestSection() {
  const [tab, setTab] = useState<"latest" | "rating" | "popular">("latest");
  const navigate = useNavigate();

  const list = useMemo(
    () => filterTitles(getTrending(18), { sort: tab as SortValue }).slice(0, 10),
    [tab],
  );

  return (
    <section className="w-full px-4 md:px-6 pt-14 md:pt-20">
      <div className="flex flex-col sm:flex-row sm:items-end justify-between gap-4 mb-6 md:mb-8">
        <SectionTitle
          accentLabel="Now Showing"
          title="最新影片"
          subtitle="从院线新片到口碑剧集，按你的节奏挑选下一部。"
        />
        <div className="flex items-center gap-2 shrink-0">
          <div className="flex items-center gap-1 p-1 rounded-full bg-background-100 border border-background-200">
            {tabs.map((t) => (
              <button
                key={t.key}
                type="button"
                onClick={() => setTab(t.key)}
                className={`px-3 py-1.5 rounded-full text-xs font-medium transition-colors whitespace-nowrap cursor-pointer ${
                  tab === t.key
                    ? "bg-primary-500 text-background-50"
                    : "text-foreground-600 hover:text-foreground-950"
                }`}
              >
                {t.label}
              </button>
            ))}
          </div>
          <Link
            to="/category/movie"
            className="hidden lg:inline-flex items-center gap-1 h-9 px-4 rounded-full border border-background-200 text-xs text-foreground-700 hover:border-secondary-400 transition-colors whitespace-nowrap cursor-pointer"
          >
            全部影片
            <i className="ri-arrow-right-line w-3.5 h-3.5 flex items-center justify-center" />
          </Link>
        </div>
      </div>

      <div className="grid grid-cols-2 sm:grid-cols-3 md:grid-cols-4 xl:grid-cols-5 gap-3 md:gap-5">
        {list.map((item, i) => (
          <div key={item.id} className="cc-fade-up">
            <FilmCard item={item} index={i} />
          </div>
        ))}
      </div>

      <div className="mt-6 flex justify-center sm:hidden">
        <button
          type="button"
          onClick={() => navigate("/category/movie")}
          className="h-10 px-6 rounded-md border border-background-200 text-sm text-foreground-700 cursor-pointer"
        >
          查看全部影片
        </button>
      </div>
    </section>
  );
}